import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const ContactAdministratorRoute: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContactAdministratorPageComponent" */ '@confluence/contact-administrator/entry-points/ContactAdministratorPage.ts'
			)
		).ContactAdministratorPage,
});

(ContactAdministratorRoute as any).NAVIGATION_PARAMS = () => {
	return {
		Screen: {
			screenEvent: { name: 'contactAdministratorScreen' },
		},
		MainLayout: {
			navView: PRODUCT_HOME_ID,
		},
	};
};
